import { jsx as _jsx } from "react/jsx-runtime";
import FormattedPropertyCurrencyV2 from './FormattedPropertyCurrencyV2';
import { usePropertyDefinition } from '../hooks/usePropertyDefinition';
import { getCurrencyCodeForPriceProperty } from 'customer-data-objects/lineItem/PropertyNames';

const FormattedPropertyPrice = props => {
  const propertyDefinition = usePropertyDefinition();
  const currencyCode = getCurrencyCodeForPriceProperty(propertyDefinition.name);
  let {
    currencyProps
  } = props; // Override currency code if one is has not been provided

  if (currencyCode && (!currencyProps || !currencyProps.currencyCode)) {
    currencyProps = Object.assign({}, props.currencyProps, {
      currencyCode
    });
  }

  return /*#__PURE__*/_jsx(FormattedPropertyCurrencyV2, Object.assign({}, props, {
    currencyProps: currencyProps
  }));
};

export default FormattedPropertyPrice;